// Подключаем React
import * as React from "react";

// Подключаем необходимые нам компоненты
import { WidgetGrid, WidgetGridModel, WidgetFrame, TextCard, Text }
  from "../studio/index.js";
// Файл "../studio/index.js" реэкспортирует все компоненты модулей:
// studio, frame и form; их можно подключить в одной строке.

// Экспорт страницы:
export { HomeSample };

/**
 * Главная страница Личной студии.
 * @returns {JSX.Element}.
 */
function HomeSample() {
  const model = new WidgetGridModel(
    {
      prefix: "/sample/home/",
      contract_id: 123,
      widget:
      {
        StudyDiffWidget: <StudyDiffWidget />, // Виджет "Академическая разница"
        StudyCalendarWidget: <StudyCalendarWidget />, // Виджет "Календарь"
        StudyPaymentWidget: <StudyPaymentWidget />, // Виджет "Ваш баланс"
        StudyGraphWidget: <StudyGraphWidget />, // Виджет "Динамика освоения"
        StudyProgressWidget: <StudyProgressWidget />, // Виджет "Прогресс обучения"
        SocialWidget: <SocialWidget />, // Социальные сети
        WelcomeWidget: <WelcomeWidget />, // Будем рады Вас видеть...
        AddWidget: <AddWidget />, // Добавить виджет
      },
      grid:
        [
          { id: "StudyDiffWidget", colspan: 2 },
          { id: "StudyCalendarWidget", colspan: 1 },
          { id: "StudyPaymentWidget", colspan: 1 },
          { id: "StudyGraphWidget", colspan: 2 },
          { id: "StudyProgressWidget", colspan: 3 },
          { id: "SocialWidget", colspan: 3 },
          { id: "WelcomeWidget", colspan: 2 },
          { id: "AddWidget", colspan: 1 },
        ]
    });
  return (
    <>
      <h1>Добро пожаловать, <Text type="primary">User!</Text></h1>
      {/* WidgetGrid - создаёт сетку для виджетов из 3-х столбцов. */}
      <WidgetGrid {...model} />
    </>
  );
}

// Создаём примеры виджетов.
// Обычно, каждый виджет определяется в отдельном файле

// Начнём с простого.

// Виджет "Календарь" занимает одну ячейку в сетке,
// имеет жёлтую (type="yellow") иконку (icon="calendar")
// и заголовок "Календарь".
function StudyCalendarWidget() {
  return (
    <WidgetFrame
      type="yellow"
      icon="calendar"
      title="Календарь">
      Содержимое виджета
    </WidgetFrame>
  );
}

// Виджет "Динамика освоения образовательной программы"
// аналогичен календарю, но иконка зелёная (type="green")
function StudyGraphWidget() {
  return (
    <WidgetFrame
      type="green"
      icon="graph"
      title="Динамика освоения образовательной программы">
      Содержимое виджета
    </WidgetFrame>
  );
}

// Виджет "Прогресс обучения"
function StudyProgressWidget() {
  return (
    <WidgetFrame
      type="blue"
      icon="study"
      title="Прогресс обучения">
      Содержимое виджета
    </WidgetFrame>
  );
}

// Виджет "Академическая разница".
// В качестве заголовка может быть любая ReactNode. 
function StudyDiffWidget() {
  return (
    <WidgetFrame
      type="burgundy"
      icon="folder_open"
      title={
        <>
          Академическая разница
          <Text type="secondary"> 24</Text>
        </>
      }>
      Содержимое виджета
    </WidgetFrame>
  );
}

// Виджет "Ваш баланс". Основной виджет (type="primary").
// Отображается на синем фоне в инвертированных цветах.
// Дизайна пока нет, но уже можно пользоваться
// className задаёт дополнительные классы, например, фоновое изображение
function StudyPaymentWidget() {
  return (
    <WidgetFrame
      type="primary"
      icon="money"
      title="Ваш баланс"
      className="payment_widget">
      Содержимое виджета
    </WidgetFrame>
  );
}

// Виджет "Присоединяйтесь к нам в социальных сетях"
// не имеет заголовка (type = "none")
function SocialWidget() {
  return (
    <WidgetFrame type="none">
      <TextCard>
        <h4>Присоединяйтесь к нам в социальных сетях:</h4>
      </TextCard>
    </WidgetFrame>
  );
}

// Виджет "Будем рады Вас видеть..."
function WelcomeWidget() {
  return (
    <WidgetFrame type="none">
      <TextCard>
        <h4>Будем рады Вас видеть...</h4>
      </TextCard>
    </WidgetFrame>
  );
}

// Виджет "Добавить виджет"
function AddWidget() {
  return (
    <WidgetFrame type="none">
      <TextCard>
        <h4>Добавить виджет</h4>
      </TextCard>
    </WidgetFrame>
  );
}

/**
 * Название примера для SampleRouter.
 * @private
 */
HomeSample.title = "Личная студия";
